
<template>
  <div class="captcha-wrap">
    <div :id="'shing-ali-captcha-ele-'+scene"></div>
    <div id="shing-ali-btn"></div>
    <div class="init-err" v-if="!loading && !initSucc">{{ tlang('verificationAliCodeInitErr') || '验证码初始化失败，请稍后重试' }}</div>
    <div class="xl-button__text" v-if="loading">
      <i class="xl-button__loading"></i>
    </div>
  </div>
</template>

<script setup>
import { VueCookieNext } from "vue-cookie-next";
import { get } from 'lodash'
import {
  defineProps,
  defineEmits,
  defineExpose,
  ref,
  onBeforeUnmount,
  watch,
  nextTick
} from "vue";
import { useUtils } from "../util/utils";
import { useLang, useIndependentLang } from "../util/lang";
import captchaApi from './api';
import { getVisitorId } from './initVisitorId';

const props = defineProps({
  positionId: { // 阿里验证码2.0无感知二次验证弹框出来相对居中的元素，如无则屏幕居中
    type: String,
    default: ''
  },
  customLang:String,
  scene:{
    type: String,
    default: 'register'
  },
  productKey:String,
  currentNode:String,
  checkAsk: {
    type: Function
  },
  webType: {
    type: String,
    default: 'web'
  },
  slideStyle: Object,
  loginType: String
});

let captcha;
const aliyunCaptchaIsLoad = ref(false);
const Utils = useUtils();
const showCaptcha = ref(false);
const loading = ref(true);
const initSucc = ref(false);
const sceneID = ref('1v8frb9x'); // 阿里验证码场景ID 1i06gpbd
const region = ref('hz');
const token = ref(''); // 验证码token
const uniqueID = ref(''); // 场景唯一ID
const needShowNow = ref( false ); // 初始完验证码后是否需要立即弹出验证码
const rootUrl = Utils.getRootUrl(props.productKey)

const emits = defineEmits(["finish"]);

const usedLang = props.customLang || VueCookieNext.getCookie('lang') || 'zh-cn';
const language = usedLang == 'zh-cn' ? 'cn' : ( usedLang === 'ja-jp' ? 'ja' : 'en' );
const currentNode = props.currentNode || get( window, 'app.global.currentNode' );


let { $t:tlang } = useLang("@shining3d/xl-login");
if ( props.customLang ) {
  tlang = useIndependentLang("@shining3d/xl-login", props.customLang).$t;
}

// 清楚阿里验证码，保证每次实例化前环境是干净的。阿里验证码问题，后续他们会优化
function clearAliCap() {
  try {
    const removeElementsById = (elementId) => {
      const elements = document.querySelectorAll(`#${elementId}`);
      elements.forEach((element) => {
          element.parentNode.removeChild(element);
      });
    };
    removeElementsById('aliyunCaptcha-mask');
    removeElementsById('aliyunCaptcha-window-popup');
  } catch(e) {
    console.log(e)
  }
}

function initCap() {
  console.log('开始初始化阿里验证码');
  clearAliCap();
  // 嵌入式
  initAliyunCaptcha({
    SceneId: sceneID.value, //  5j7qu2pi 场景ID。通过步骤一添加验证场景后，您可以在验证码场景列表，获取该场景的场景ID 1i06gpbd
    prefix: "1dtwak", // 1s51su 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标 xfaf27
    mode: "embed", // 验证码模式。embed表示要集成的验证码模式为嵌入式。无需修改 popup
    element: "#shing-ali-captcha-ele-"+props.scene, // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
    button: "#shing-ali-btn", // 触发业务请求的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
    captchaVerifyCallback: captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
    onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
    getInstance: getInstance, // 绑定验证码实例函数，无需修改
    slideStyle: props.slideStyle, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
    language: language, // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
    immediate: true, // 完成验证后，是否立即发送验证请求（调用captchaVerifyCallback函数）
    region: currentNode === 'hz' ? 'cn' : 'sgp'
  });
}

// 加载完阿里jssdk和获取到场景ID后，实例化验证码
watch(
  () => [aliyunCaptchaIsLoad.value, initSucc.value],
  ( val ) => {
    if ( val[ 0 ] && val[ 1 ] ) {
      nextTick(() => {
        initCap();
      });
    }
  },
  { deep:true, immediate: true }
);

function initData(res, type){
  if(captcha){
    refresh();
  } else {
    if(type === 2){
      needShowNow.value = true;
      initSucc.value = true;
    }
    if(res){
      token.value = get(res, 'token', '');
      uniqueID.value = get(res, 'uniqueID' , '');
      sceneID.value = get(res, 'sceneID', '');
      region.value = get(res, 'region', '');
    } else {
      loading.value = false;
      initSucc.value = false;
      showCaptcha.value = true;
    }
  }
}
// init();

// 绑定验证码实例函数。该函数为固定写法，无需修改
function getInstance( instance ) {
  console.log('验证码实例化成功');
  loading.value = false;
  showCaptcha.value = false;

  captcha = instance;

  // 实力化后立马弹出
  if (needShowNow.value) {
    doVerify();
  }
}

// 业务请求(带验证码校验)回调函数
/**
 * @name verifyCaptchaCallback
 * @function
 * 请求参数：由验证码脚本回调的验证参数，不需要做任何处理，直接传给服务端即可
 * @params {string} captchaVerifyParam
 * 返回参数：字段名固定，captchaResult为必选；如无业务验证场景时，bizResult为可选
 * @returns {{captchaResult: boolean, bizResult?: boolean|undefined}}
 */
async function captchaVerifyCallback( captchaVerifyParam ) {
  console.log("前端一次验证通过", captchaVerifyParam);
  needShowNow.value = false;
  let captchaResult = false;
  // 保持1.0模式和自研验证码的调用方式
  const param = {
    uniqueID: uniqueID.value,
    token: token.value,
    captchaVerifyParam,
  };
  const visitorId = await getVisitorId();

  const checkAsk = props.checkAsk || captchaApi.captchaFusionAuthCheck;
  const res = await checkAsk({ param: JSON.stringify(param) }, rootUrl, { headers: {'X-Client-ID': visitorId }}, props.productKey );
  if ( res && res.status === 'success' ) {
    const result = res.result;
    captchaResult = result.verifyResult;
    const info = {
      uniqueID: uniqueID.value,
      token: token.value
    };

    if ( captchaResult ) {
      // 无痕验证成功
      emits( 'finish', { flag: true, result: info } )
    }
    // 无痕二次挑战失败，是否需要重新初始化验证码
    if ( !captchaResult && result.reload ) {
      captcha.destroyCaptcha();

      emits('resetInit', () =>{
        if ( initSucc.value ) {
          initCap();
          // 验证码初始化成功后，需要立即弹出进行再次验证
          needShowNow.value = true;
        } else {
          needShowNow.value = false;
        }
      }, true )
    } else {
      // 无痕验证成功/失败，会自动进行二次挑战
      return {
        captchaResult
      }
    }
  } else {
    return {
      captchaResult: false
    }
  }
}

// 业务请求结果回调函数
function onBizResultCallback() {}
// 兼容自研验证码写法，阿里2.0无痕不可刷新验证码
function resetCaptcha() {}

function doVerify() {
  if ( loading.value || !aliyunCaptchaIsLoad.value || !initSucc.value ) {
    emits( 'finish', { flag: false, result: { "validType": tlang('captchaVerifyAlertText') || '请先进行校验' } } );
  }
}

onBeforeUnmount(() => {
  // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
  if (document.getElementById('aliyunCaptcha-mask')) {
    document.getElementById('aliyunCaptcha-mask').remove();
  }
  if (document.getElementById('aliyunCaptcha-window-popup')) {
    document.getElementById('aliyunCaptcha-window-popup').remove();
  }
  captcha = null;
});

const refresh = () => {
  captcha.refresh();
}

// 加载阿里验证码2.0的sdk
(() => {
  Utils.loadAliyunCaptchaNew(aliyunCaptchaIsLoad);
})();

defineExpose({ showCaptcha, resetCaptcha, initData, refresh });
</script>
  
<style lang="scss" scoped>
.captcha-wrap {
  width: 100%;
  position: relative;
}
.captcha-show {
  margin-top: 16px;
  height: 30px;
  margin-bottom: 5px !important;
}
.xl-button__text {
  height: 36px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.init-err {
  color: var(--el-color-danger);
  font-size: 12px;
  line-height: 1;
  padding-top: 12px;
}
.captcha-wrap{
  :deep(#aliyunCaptcha-window-embed){
    border: none;
    padding: 0;
  }
  :deep(.aliyunCaptcha-top),:deep(.aliyunCaptcha-line){
    display: none;
  }
  :deep(#aliyunCaptcha-img-box){
    margin-top: 0;
  }
  :deep(#aliyunCaptcha-question-box){
    margin-bottom: 8px;
  }
}
</style>  
<style lang="scss">
#aliyunCaptcha-question {
  background: #F7F8FA !important;
  color: #2C364E !important;
}
#aliyunCaptcha-sliding-body #aliyunCaptcha-sliding-slider.fail {
  background: #E64C4C !important;
}
#aliyunCaptcha-sliding-body #aliyunCaptcha-sliding-left {
  background-color: #8FCC5C !important;
}
#aliyunCaptcha-sliding-body #aliyunCaptcha-sliding-left.fail {
  background-color: #FDEEEE !important;
}

#aliyunCaptcha-sliding-wrapper {
  #aliyunCaptcha-sliding-body {
    background: var(--oem-color-n5)!important;
    border: none !important;

    #aliyunCaptcha-sliding-slider {
      background: #fff !important;
      color: #737383 !important;
      box-shadow: none !important;
      border-radius: 0px !important;
      border: 1px solid #ccc !important;
    }

    #aliyunCaptcha-sliding-left {
      background-color: #7ac23c !important;
      border-radius: 0px !important;
    }

    #aliyunCaptcha-sliding-text-box {
      .aliyunCaptcha-sliding-text {
        font-size: 12px !important;
        background-image: -webkit-gradient(linear, left top, right top, color-stop(0, #4d4d4d), color-stop(.4, #4d4d4d), color-stop(.5, #fff), color-stop(.6, #4d4d4d), color-stop(1, #4d4d4d)) !important;
      }
      .verified {
        color: #4d4d4d !important;
        font-size: 12px !important;
        background-image: none !important;
      }
    }
  }
}
</style>
